import { useQuery } from '@tanstack/react-query'
import { apiClient } from '.'
import { FullConfigurationResponse } from './Api'

export const useGetConfiguration = (code: string) => {
    const { data, error, isLoading } = useQuery<FullConfigurationResponse>({
        enabled: !!code,
        queryKey: ['configuration', code],
        queryFn: async () => {
            const result = await apiClient.configuration.getConfiguration(code)
            if (!result.ok) {
                const error = new Error(result.statusText)
                ;(error as any).status = result.status
                throw error
            }
            return result.data
        },
        retry: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
    })

    return { data, error, isLoading }
}
